module["exports"] = [
  "####-#####",
  "####-######"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/sv/phone_number/formats.js
// module id = 3607
// module chunks = 1610